import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function CBWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-516">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-517">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-518">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-519">
            WHAT IS CLEAR + BRILLIANT?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-520"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-521">
            For smoother, brighter and dewy skin without downtime for recovery,
            Clear + Brilliant Touch is an innovative laser treatment that can
            rejuvenate your skin with precision and care.
          </p>

          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-522">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-523">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-524">
              Clear + Brilliant Touch is the key to smoother, brighter, and more
              youthful skin, delivering radiant results with minimal downtime.
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-525">
            <p data-id="element-526">
              By harnessing the power of fractional laser technology, it
              effectively targets early signs of aging, sun damage and uneven
              skin texture.
            </p>
            <p data-id="element-527">
              At Be CLINICAL, Dr. Fiona loves this treatment as it's safe for
              all skin tones and types, thanks to its customizable,
              dual-wavelength technology.{' '}
              <em data-id="element-528">
                "This is my favourite Laser to combine with BBL for a 40-minute
                beauty maintenance! You owe yourself this wonderful gift on a
                monthly (or three monthly) basis. Trust me, you will look great
                forever."
              </em>
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}